import { apiClientSource } from "../common/axiosInstanceSource";
import { handleAxiosError } from "../common/handleAxiosError";

export const downloadDocFromComment = async (fileId: string) => {

  try {
    const response = await apiClientSource.get(`/task-service/api/comments/download/${fileId}`, {
      responseType: 'blob',
      headers: {
        'Accept': 'application/json, application/octet-stream'
      }
    });
    return response;
  } catch (error) {
    handleAxiosError(error, "Error al descargar el documento");
  }
}